import { Alert, AlertTitle, Box, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/root'
import {
  fetchZapierProfileAndUpsertServiceAccount,
  selectAllServiceAccounts,
  selectServiceAccountsLoadingStatus,
} from '../../store/service-account/service-accounts.slice'

interface ZapierOAuthPageProps {}

/**
 * The purpose of this component is to create or update a zapier ServiceAccount
 * upon retrieving an end-user's Zapier oauth accessToken
 * @param props
 * @returns
 */
export const ZapierOAuthPage: FC<ZapierOAuthPageProps> = (props) => {
  const dispatch = useAppDispatch()

  const serviceAccountsLoadingStatus = useAppSelector(selectServiceAccountsLoadingStatus)
  const existingZapierServiceAccounts = useAppSelector((state) =>
    selectAllServiceAccounts(state).filter((serviceAccount) => serviceAccount.integrationGroupId === 'zapier')
  )

  const [done, setDone] = useState<boolean>(false)

  // Load variables into state from hash query
  const { access_token, expires_in, state, ...hashParams } = Object.fromEntries(
    new URLSearchParams(window.location.hash.replace(/^#/, '')).entries()
  )
  // Load variables into state from query params
  const { error, error_description, ...queryParams } = Object.fromEntries(
    new URLSearchParams(window.location.search.replace(/^#/, '')).entries()
  )

  useEffect(() => {
    if (serviceAccountsLoadingStatus !== 'loaded') {
      console.log(`Not dispatching Zapier request yet because serviceAccountsLoadingStatus: ${serviceAccountsLoadingStatus}`)
      return
    }

    dispatch(fetchZapierProfileAndUpsertServiceAccount({ accessToken: access_token, openerOrigin: state }))
    setDone(true)
  }, [dispatch, access_token, state, serviceAccountsLoadingStatus])

  // if () return <Navigate to="/integrations" replace />

  // if (done) return <Navigate to="/integrations" replace />
  if (error || error_description || access_token === undefined || expires_in === undefined)
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', m: 2 }}>
        <Alert severity="error">
          <AlertTitle>There was an error connecting your Zapier Account!</AlertTitle>
          {error && `"${error}" `}
          {error_description ?? null}
          {!error && !error_description && <>Malformed URL</>}
        </Alert>
      </Box>
    )
  return <Typography sx={{ m: 2, textAlign: 'center' }}>Connecting your Zapier Account...</Typography>
}
